import styled from 'styled-components';
import LoadingMask from '../../../CommonComponents/LoadingMask';

export const StyledQuestions = styled.div`
  font-size: 14px;
`;

export const Question = styled.div`
  margin-bottom: 16px;
  font-weight: 600;
`;

export const Answers = styled.div`
  margin-bottom: 32px;

  > * {
    margin: 12px 0;
  }
`;

export const LoadingAnswer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  > * {
    margin-right: 12px;
  }
`;

export const StyledLoadingMask = styled(LoadingMask).attrs(() => ({
  isDark: true,
  isRound: true,
}))``;
